/**
 * Horodatage des enregistrements (metadonnee CLAIRE : `docs/ARCHITECTURE.md`
 * §2 autorise `createdAt`/`updatedAt`/revisions en clair, jamais le contenu).
 *
 * Toute fonction qui horodate accepte un `now` optionnel (millisecondes
 * epoch) : par defaut `Date.now()`, mais les appelants (et les tests) peuvent
 * l'imposer pour un resultat deterministe.
 */
import { InvalidVaultModelInputError } from './errors.js';

export function resolveNow(now: number | undefined): number {
  if (now === undefined) return Date.now();
  if (!Number.isInteger(now) || now < 0) {
    throw new InvalidVaultModelInputError('now: horodatage entier positif (epoch ms) attendu');
  }
  return now;
}
